import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "22",
  height: "22",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      stroke: "#FF383B",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "1.5",
      d: "M14.107 6.193v-.968A3.825 3.825 0 0 0 10.283 1.4h-5.06A3.824 3.824 0 0 0 1.4 5.225v11.55A3.824 3.824 0 0 0 5.223 20.6h5.07a3.814 3.814 0 0 0 3.814-3.813v-.978M21.158 11H8.66M18.119 7.975 21.157 11l-3.038 3.026",
      style: {"stroke":"inherit"}
    }, null, -1)
  ])))
}
export default { render: render }